// Copyright (C) 2014 Minted Inc.
// All Rights Reserved

(function(M, _, $, Backbone) {
  "use strict";

  M.View = M.View || {};
  M.View.Community = M.View.Community || {};

  M.View.Community.ConfirmChangeStatusDialog = Backbone.View.extend({
    events: {
      'click .continueChangeButton': 'continueChangeStatusClick',
      'click .cancelButton': 'cancelChangeClick',
    },

    initialize: function() {
      this.$el = $(this.el);
    },

    render: function() {
      // Only called if fetchInfoAndDisplayDialog gets info that says
      // dialog should be displayed
      var html = this.template();
      this.$el.html(html);
      this.$el.dialog({
        width: 400,
        modal: true,
        dialogClass: 'confirmChangeStatusDialog',
        closeOnEscape: true,
        draggable: false,
        resizable: false,
        close: this.trackCloseDialogEvent
      });
      return this;
    },

    renderOverlay: function(action_type, url) {
      this.url = url;
      if (action_type == 'exclusive') {
        this.template = M.Template.Community.MyProjectsExclusivePrompt;
      } else if (action_type == 'activate') {
        this.template = M.Template.Community.ConfirmActivatePrompt;
      } else if (action_type == 'deactivate') {
        this.template = M.Template.Community.ConfirmDeactivatePrompt;
      }
      this.action_type = action_type;

      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.MY_PROJECT,
        M.GA.TRACK_EVENT_ACTION.CHANGE_STATUS,
        'open-' + this.action_type
      );

      this.render();
    },

    cancelChangeClick: function() {
      // send event to GA
      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.MY_PROJECTS,
        M.GA.TRACK_EVENT_ACTION.CHANGE_STATUS,
        'cancel-' + this.action_type
      );
      this.$el.dialog('close');
    },

    continueChangeStatusClick: function() {
      var parsedUrl = M.Url.ParseUrl(this.url);
      this.url = parsedUrl.pathname;
      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.MY_PROJECTS,
        M.GA.TRACK_EVENT_ACTION.CHANGE_STATUS,
        this.action_type
      );
      window.location.pathname = this.url;
    },

    trackCloseDialogEvent: function() {
      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.MY_PROJECTS,
        M.GA.TRACK_EVENT_ACTION.CHANGE_STATUS,
        'closed-' + this.action_type
      );
    }
  });
})(M, _, $, Backbone);
